"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VersetFacilityMechanism = void 0;
var VersetFacilityMechanism;
(function (VersetFacilityMechanism) {
    function install(option) {
        const g = globalThis;
        if (option.app) {
            VersetFacilityMechanism.app = option.app;
            VersetFacilityMechanism.services = option.app.services;
            g.app = option.app;
            g.services = option.app.services;
        }
        if (option.server) {
            VersetFacilityMechanism.server = option.server;
            g.server = option.server;
        }
        if (option.agreement) {
            VersetFacilityMechanism.agreement = option.agreement;
            g.agreement = option.agreement;
        }
        if (option.services) {
            VersetFacilityMechanism.services = option.services;
            g.services = option.services;
        }
    }
    VersetFacilityMechanism.install = install;
    function ensureServer() {
        const currentServer = VersetFacilityMechanism.server;
        if (!currentServer) {
            throw new Error("Verset server is not initialized");
        }
        return currentServer;
    }
    VersetFacilityMechanism.ensureServer = ensureServer;
    function clear() {
        VersetFacilityMechanism.agreement = undefined;
        VersetFacilityMechanism.server = undefined;
        VersetFacilityMechanism.services = undefined;
        VersetFacilityMechanism.app = undefined;
        globalThis.agreement = undefined;
        globalThis.server = undefined;
        globalThis.services = undefined;
        globalThis.app = undefined;
    }
    VersetFacilityMechanism.clear = clear;
    function ensureApp() {
        const currentApp = VersetFacilityMechanism.app;
        if (!currentApp) {
            throw new Error("Verset app is not initialized");
        }
        return currentApp;
    }
    VersetFacilityMechanism.ensureApp = ensureApp;
    function ensureServices() {
        const currentServices = VersetFacilityMechanism.services;
        if (!currentServices) {
            throw new Error("Verset services are not initialized");
        }
        return currentServices;
    }
    VersetFacilityMechanism.ensureServices = ensureServices;
})(VersetFacilityMechanism || (exports.VersetFacilityMechanism = VersetFacilityMechanism = {}));
